/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsTextIcon24Solid = forwardRef('DocsTextIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 1h4.05v5.3a2.75 2.75 0 0 0 2.75 2.75H19V17a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4Zm.25 14.05a.75.75 0 0 0 0 1.5h4.25a.75.75 0 1 0 0-1.5H7.25ZM6.5 12.8a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M19 7.51v.04h-5.2c-.69 0-1.25-.56-1.25-1.25V1.06L19 7.51Z" }),
        React.createElement("path", { d: "M21.75 9a.75.75 0 0 0-1.5 0v8.5a4.75 4.75 0 0 1-4.75 4.75H9a.75.75 0 0 0 0 1.5h6.5a6.25 6.25 0 0 0 6.25-6.25V9Z" })));
});
